import selectMember from '@/common/select-user/select-user.vue'
export const mixin = {
  data: function () {
    return {
      deleteIconVisible:false,
      addBtnVisible: true,
      deleteBtnVisible: true,
      selectMemberModel: { // 选人组件
        //
        isShow: false,
        selectList: [],
        callBack: this.selectMemberCallback,
        radioSelectFlags: true
      }
    }
  },
  props: {
    single: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    readOnly: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    max: {
      type: Number,
      default: function () {
        return 1000
      }
    }
  },
  computed:{

  },
  created () {

  },
  mounted () {

  },
  methods: {
    addUser(){
      if(this.selectMemberModel.selectList.length>=this.max){
        this.util.warn('只能选择'+this.max+'个人')
        return
      }
      this.selectMemberModel.isShow = true
    },
    deleteUser(){
      this.deleteIconVisible = !this.deleteIconVisible
    },
    removeUser(user){
      this.selectMemberModel.selectList = this.selectMemberModel.selectList.filter(
        item => {
          return item != user
        }
      )
    },
    selectMemberCallback(){

      this.selectMemberModel.isShow = false
    },
    getSelectedData(){
      return this.selectMemberModel.selectList
    }
  },
  components: {
    selectMember
  }
}



// WEBPACK FOOTER //
// ./src/common/select-user-cmp/mixin.js